import { useContext } from "react";
import {
  Modal,
  Typography,
  Paper,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  useTheme,
  Grid2,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toggleThemeModal } from "../store/slicers/General Slicer";
import { ThemeSwitcherContext } from "../style/Theme Provider Wrapper";
import { themesList } from "../style/themes collection";

const CARD_SCALE_MODIFIER = 1.5;
const BORDER_WIDTH = 1;
const THUMBNAIL_WIDTH = 106;
const THUMBNAIL_HEIGHT = 66;

const ThemeCard = (props) => {
  const { themeName, setThemeName } = useContext(ThemeSwitcherContext);
  const isActive = themeName === props.themeName;
  return (
    <Card sx={{ maxWidth: THUMBNAIL_WIDTH * CARD_SCALE_MODIFIER }}>
      <CardActionArea
        onClick={() => setThemeName(props.themeName)}
        data-active={isActive ? "" : undefined}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          height: "100%",
          "&[data-active]": {
            borderWidth: BORDER_WIDTH,
            borderStyle: "solid",
            borderColor: "primary.main",
            "&:hover": {
              backgroundColor: "action.selectedHover",
            },
          },
        }}>
        <CardMedia
          sx={{
            borderRadius: "4px 4px 0 0",
            width:
              THUMBNAIL_WIDTH * CARD_SCALE_MODIFIER -
              (isActive ? BORDER_WIDTH * 2 : 0),
            height: THUMBNAIL_HEIGHT * CARD_SCALE_MODIFIER,
          }}
          image={props.thumbnailPath}
          title={`${props.themeName} thumbnail`}
        />
        <CardContent>
          <Typography gutterBottom variant="titleSmall">
            {props.themeName}
          </Typography>
          <Typography variant="bodySmall" sx={{ color: "text.secondary" }}>
            {props.themeDescription}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const ThemeChangeModal = () => {
  //#region Hooks
  const themeObj = useTheme();
  const dispatch = useDispatch();
  const { isThemeModalOpen = false } = useSelector(
    (state) => state.general || {}
  );
  //#endregion

  //#region Methods
  const handleClose = () => dispatch(toggleThemeModal(false));
  //#endregion
  return (
    <Modal open={isThemeModalOpen} onClose={handleClose}>
      <Paper
        elevation={0}
        sx={{
          position: "absolute",
          py: 1,
          px: 2,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflowY: "auto",
          maxHeight: "50rem",
        }}>
        <Typography variant="titleMedium" sx={{ mb: 1 }}>
          Select a theme
        </Typography>
        <Grid2
          container
          sx={{ alignItems: "flex-start" }}
          spacing={{ xs: 1, md: 2 }}
          columns={{ xs: 1, sm: 2, md: 3 }}>
          {themesList.map((theme) => (
            <Grid2
              size={1}
              key={theme.name}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <ThemeCard
                themeName={theme.name}
                themeDescription={theme.description}
                thumbnailPath={
                  themeObj.palette.mode === "light"
                    ? theme.lightThumbnailPath
                    : theme.darkThumbnailPath
                }
              />
            </Grid2>
          ))}
        </Grid2>
      </Paper>
    </Modal>
  );
};

export default ThemeChangeModal;
